export default __webpack_public_path__ + "static/media/road-map-top-1.b824e9d6.png";